<template>
  <v-card>
    <v-card-title>
      <h4>{{ this.title }}</h4>
    </v-card-title>
    <v-card-text>
      <v-form ref="form" v-model="formValid">
        <v-text-field label="ユーザーID（メールアドレス）" required
                      v-model="userId" :rules="requiredFieldRules"
                      :disabled="currentUser !== null"
        />

        <div v-if="currentUser === null">
          <v-text-field label="パスワード" required type="password"
                        v-model="password" :rules="requiredFieldRules"
          />
          <v-text-field label="パスワード（確認）" required type="password"
                        v-model="passwordRetype" :rules="passwordRetypeRules"
          />
        </div>

        <v-layout row wrap>
          <v-flex xs12 sm6>
            <v-text-field label="姓" required
                          v-model="lastName" :rules="requiredFieldRules"
            />
          </v-flex>
          <v-flex xs12 sm6>
            <v-text-field label="姓（かな）" required
                          v-model="lastNameKana" :rules="requiredFieldRules"
            />
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs12 sm6>
            <v-text-field label="名" required
                          v-model="firstName" :rules="requiredFieldRules"
            />
          </v-flex>
          <v-flex xs12 sm6>
            <v-text-field label="名（かな）" required
                          v-model="firstNameKana" :rules="requiredFieldRules"
            />
          </v-flex>
        </v-layout>
      </v-form>

      <h6>お持ちの製品を選択してください。</h6>
      <product-select ref="productSelect"
                      @load-master="onLoadProductMaster"
      />

      <v-alert warning v-model="visibleErrMessage" v-text="errMessage" />
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <v-btn flat class="indigo--text darken-2" @click="save">
        {{ saveBtnLabel }}
      </v-btn>
      <v-btn flat class="red--text darken-2" @click="cancel">キャンセル</v-btn>
      <v-spacer />
    </v-card-actions>
  </v-card>
</template>

<script>
import BaseComponent from '@/components/BaseComponent'
import ProductSelect from '@/components/ProductSelect'

// 必須項目ルール
const requiredRule = (v) => !!v || '必須項目です。'

export default {
  name: 'UserReg',
  extends: BaseComponent,
  components: {
    ProductSelect
  },
  data: function () {
    return {
      title: '',
      saveBtnLabel: '',

      userId: null,
      password: null,
      passwordRetype: null,
      firstName: null,
      firstNameKana: null,
      lastName: null,
      lastNameKana: null,

      formValid: true,
      requiredFieldRules: [requiredRule],

      visibleErrMessage: false,
      errMessage: null
    }
  },
  computed: {
    passwordRetypeRules () {
      return [
        (v) => {
          if (!this.password) return true
          if (v === this.password) return true

          return 'パスワードが一致しません。'
        }
      ]
    }
  },
  created () {
    this.title = this.currentUser ? 'プロフィール編集' : '新規ユーザー登録'
    this.saveBtnLabel = this.currentUser ? '保存' : '登録'
  },
  methods: {
    // 製品マスターロード完了時
    onLoadProductMaster () {
      if (this.currentUser) {
        this.loadProfile()
      }
    },

    // 現在のプロフィール取得
    loadProfile () {
      this.api.getEndUserProfile().then(res => {
        this.userId = res.data.user_id
        this.firstName = res.data.first_name
        this.firstNameKana = res.data.first_name_kana
        this.lastName = res.data.last_name
        this.lastNameKana = res.data.last_name_kana

        this.$refs.productSelect.setSelectedIds(res.data.owned_product_ids)
      })
      .catch(err => {
        this.handleError('ユーザープロフィールの取得に失敗しました。', err)
      })
    },

    save () {
      if (!this.$refs.form.validate()) return

      if (this.currentUser) {
        this.updateProfile()
      } else {
        this.regUser()
      }
    },

    // プロフィール更新
    updateProfile () {
      let update = this.api.updateEndUserProfile({
        firstName: this.firstName,
        firstNameKana: this.firstNameKana,
        lastName: this.lastName,
        lastNameKana: this.lastNameKana,
        ownedProductIds: this.$refs.productSelect.selectedProductIds
      })
      update.then(res => {
        this.$router.go(-1)
      })
      .catch(err => {
        this.handleError('プロフィールの更新に失敗しました。', err)
      })
    },

    // 新規ユーザー登録
    regUser () {
      let create = this.api.createEndUser({
        userId: this.userId,
        password: this.password,
        firstName: this.firstName,
        firstNameKana: this.firstNameKana,
        lastName: this.lastName,
        lastNameKana: this.lastNameKana,
        ownedProductIds: this.$refs.productSelect.selectedProductIds
      })
      create.then(res => {
        this.login(this.userId, this.password)
      })
      .catch(err => {
        if (err.response && err.response.status === 409) {
          this.errMessage = `ユーザーID ${this.userId} はすでに使用されています。`
          this.visibleErrMessage = true
        } else {
          this.handleError('ユーザー登録に失敗しました。', err)
        }
      })
    },

    // キャンセル
    cancel () {
      this.$router.go(-1)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/UserReg.vue?67e8814f